export default "__VITE_ASSET__V9ag$pSZ__"